"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToDayNameString = void 0;
function transformDateToDayNameString(date) {
    return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][date.getDay()];
}
exports.transformDateToDayNameString = transformDateToDayNameString;
//# sourceMappingURL=transformDateToDayNameString.js.map